<template>
  <div v-if="event" class="row">
    <div class="col-12">
      <div v-if="event.tickets && event.tickets.length > 0" class="card hg-topline" :style="topLineOverride">
        <div class="card-body">
          <table class="table table-tickets">
            <!--<col style="width: 40px" />
            <col style="width: 25%" />  -->
            <thead>
            <tr>
              <th></th>
              <th :style="{'color': event.phcolor}">Ticket Name</th>

              <th v-if="hasEarlyBird"
                  :style="earlyBirdValid ? {'color': event.phcolor} : {'color': 'gray',  'text-decoration': 'line-through'}">
                Early Bird Cost ({{ event.vat_exclusive ? 'exc' : 'inc' }} VAT)
                <el-popover style="display:inline-block" placement="top-start" title="Dates Valid" width="200"
                            trigger="hover" :content="earlyBirdInfo">
                  <div slot="reference">
                    <i class="fa fa-lg fa-info-circle"></i>
                  </div>
                </el-popover>

              <th v-if="hasPaidTickets"
                  :style="earlyBirdValid && hasEarlyBird ? {'color': 'gray'} : {'color': event.phcolor}">
                Cost ({{ event.vat_exclusive ? 'exc' : 'inc' }} VAT)
                <el-popover v-if="earlyBirdValid" style="display:inline-block" placement="top-start" title="Dates Valid"
                            width="200" trigger="hover" :content="earlyBirdInfoExp">
                  <div slot="reference">
                    <i class="fa fa-lg fa-info-circle"></i>
                  </div>
                </el-popover>

              <th v-if="vatable">VAT Amount</th>
              <th v-if="vatable">Total to Pay</th>
              <th :style="{color: event.phcolor}" v-if="event.show_tickets_remaining">Tickets Remaining
              </th>
              <th>Ticket Date & Time</th>
              <th :style="{color: event.phcolor}">Number of tickets</th>
            </tr>
            </thead>
            <ticket-row v-for="ticket in event.tickets" :disabled="readonly" :event="event"
                        :ticket="ticket"></ticket-row>
          </table>
        </div>
      </div>

      <div class="card hg-topline headerGroup" :style="topLineOverride" v-for="ticketGroup in event.ticket_groups">
        <div class="card-header">
          <div class="row">
            <b-col sm="12">
              <h3>{{ ticketGroup.description }}</h3>
            </b-col>
          </div>
        </div>
        <div class="card-body">
          <table class="table table-tickets">
            <thead>
            <tr>
              <th></th>
              <th :style="{'color': event.phcolor}">Ticket Name</th>

              <th v-if="hasEarlyBird"
                  :style="earlyBirdValid ? {'color': event.phcolor} : {'color': 'gray',  'text-decoration': 'line-through'}">
                Early Bird Cost ({{ event.vat_exclusive ? 'exc' : 'inc' }} VAT)
                <el-popover style="display:inline-block" placement="top-start" title="Dates Valid" width="200"
                            trigger="hover" :content="earlyBirdInfo">
                  <div slot="reference">
                    <i class="fa fa-lg fa-info-circle"></i>
                  </div>
                </el-popover>
              </th>

              <th v-if="hasPaidTickets"
                  :style="earlyBirdValid && hasEarlyBird ? {'color': 'gray'} : {'color': event.phcolor}">
                Cost ({{ event.vat_exclusive ? 'exc' : 'inc' }} VAT)
                <el-popover v-if="earlyBirdValid" style="display:inline-block" placement="top-start" title="Dates Valid"
                            width="200" trigger="hover" :content="earlyBirdInfoExp">
                  <div slot="reference">
                    <i class="fa fa-lg fa-info-circle"></i>
                  </div>
                </el-popover>
              </th>

              <th v-if="vatable">VAT Amount</th>
              <th v-if="vatable">Total to Pay</th>
              <th :style="{color: event.phcolor}" v-if="event.show_tickets_remaining">Tickets Remaining
              </th>
              <th>Ticket Date & Time</th>
              <th :style="{color: event.phcolor}">Number of tickets</th>
            </tr>
            </thead>

            <ticket-row v-for="ticket in ticketGroup.packages" :disabled="readonly" :event="event"
                        :ticket="ticket"></ticket-row>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ticketRow from "./ticket-row";
import EventBus from "../../events/event-bus";
import ticketMixins from "./tickets-mixin";
import {mapGetters} from 'vuex';

export default {
  props: ["event", "eventBooking"],

  components: {
    ticketRow: ticketRow
  },

  mixins: [ticketMixins],

  data() {
    return {
      // discountValid: false,
      previewOnly: false,
      editMode: true,
      selectedTickets: [],
      vatRate: window.vatRate,
      readonly: this.$store.getters.getReadOnly,
      editable: this.$route.query.mode == "edit"
    };
  },

  computed: {
    ...mapGetters({
      hasPaidTickets: 'getChargeable'
    })
  },

  created() {
    var self = this;

    if (!this.event.phcolour) {
      this.event.phcolour = "#FF9500";
    }

    if (this.readonly) this.showPrevBookingData(); //=ON codition of being booked already

    EventBus.$on("setTicket", function (ticket) {
      self.setTicket(ticket);
    });

    var ticketsRemainingTotal = 0;

    this.event.tickets.forEach(ticket => {
      ticketsRemainingTotal += ticket.tickets_remaining;
    });

    this.event.ticket_groups.forEach(tg => {
      tg.packages.forEach(ticket => {
        ticketsRemainingTotal += ticket.tickets_remaining;
      });
    });

    if (ticketsRemainingTotal == 0) {
      this.$notify.warning({
        title: "Warning",
        message: "There are no tickets remaining for this event!"
      });
    }
  },

  methods: {
    showPrevBookingData() {
      var self = this;

      // this.editMode = true; //Needs to meet conditions set on Store

      this.eventBooking.package_bookings = this.eventBooking.package_bookings.filter(
          pb => {
            return !pb.cancelled_at;
          }
      );


      this.eventBooking.package_bookings.forEach(pb => {
        self.event.tickets.forEach(ticket => {
          if (pb.package_id == ticket.id) {
            ticket.quantity_tickets = pb.quantity_tickets;
            ticket.sub_options_selected = pb.sub_options_selected;
            ticket.attendees = [];

            pb.registered_users.forEach(ru => {
              ru.registered_user_responses_attributes =
                  ru.registered_user_responses || [];
              var regUser = {
                registered_user_attributes: ru
              };

              ticket.attendees.push(regUser);
            });
            self.selectedTickets.push(ticket);
          }
          ticket.child_tickets.forEach(ct => {
            if (pb.package_id == ct.id) {
              ct.quantity_tickets = pb.quantity_tickets;
              self.selectedTickets.push(ct);
            }
          });
        });

        self.event.ticket_groups.forEach(tg => {
          tg.packages.forEach(ticket => {
            if (pb.package_id == ticket.id) {
              ticket.quantity_tickets = pb.quantity_tickets;
              ticket.sub_options_selected = pb.sub_options_selected;
              ticket.attendees = [];
              ticket.group_name = tg.description;
              pb.registered_users.forEach(ru => {
                ru.registered_user_responses_attributes =
                    ru.registered_user_responses || [];

                var regUser = {
                  registered_user_attributes: ru
                };

                ticket.attendees.push(regUser);
              });
              self.selectedTickets.push(ticket);
            }
            ticket.child_tickets.forEach(ct => {
              if (pb.package_id == ct.id) {
                ct.quantity_tickets = pb.quantity_tickets;
                self.selectedTickets.push(ct);
              }
            });
          });
        });
      });

      self.$store.commit("setSelectedTickets", self.selectedTickets);
    },

    setTicket(ticket) {
      ticket.attendees = [];

      if (!ticket.child_ticket) {
        if (ticket.ticket_group_id) {
          var ticketGroup = this.event.ticket_groups.find(
              tg => tg.id === ticket.ticket_group_id
          );

          if (ticketGroup) {
            ticket.group_name = ticketGroup.description;
          }
        }
        //No attendee for child ticket, that comes via the parent
        // Changed 25 Jul 2018, now adding group amount, so for group tickets ALL attendees are registered
        var noAttendees = ticket.quantity_tickets;
        if (ticket.details_for_all_group_members) {
          noAttendees = noAttendees * ticket.group_amount;
        }

        for (var i = 0; i < noAttendees; i++) {
          var attendee = {
            selected: null,
            idx: i,
            uniq:
                "_" +
                Math.random()
                    .toString(36)
                    .substr(2, 9)
          };
          if (!ticket.attendees) {
            ticket.attendees = [];
          }
          ticket.attendees.push(attendee);
        }
      } else {
        if (!ticket.from_basic) {
          //Child ticket is created on attendee screen NOT booking
          ticket.quantity_tickets = this.$store.getters.getChildTicketTotalBooked(
              ticket.id
          );
        }
      }

      if (this.selectedTickets.length > 0) {
        var ticketIndex = this.selectedTickets.indexOf(ticket);
        if (ticketIndex > -1) {
          this.selectedTickets.splice(ticketIndex, 1);
        }

        // Iterate through ticket.childtickets and do as above to remove child tickets belonging to the parent
        if (ticket.child_tickets) {
          ticket.child_tickets.forEach(ct => {
            var cTicketIndex = this.selectedTickets.indexOf(ct);
            if (cTicketIndex > -1) {
              ct.quantity_tickets = 0;
              ct.attendees = [];
              this.selectedTickets.splice(cTicketIndex, 1);
            }
          });
        }
      }

      if (ticket.quantity_tickets > 0) {
        this.selectedTickets.push(ticket);
      }

      this.$store.commit("setSelectedTickets", this.selectedTickets);
    },

    completeSelections() {
      if (this.selectedTickets.length == 0) {
        this.$notify.error({
          message: "Please select at least one ticket",
          title: "Choose Tickets"
        });
        return false;
      }

      // if (!this.event.show_add_attendees) {
      //   if (!this.validateMenuOptions(this.selectedTickets)) {
      //     return false;
      //   }
      // }

      this.$store.commit("setSelectedTickets", this.selectedTickets);
      return true;
    },

    // validateMenuOptions(tickets) {
    //   var validMenuItems = true;
    //
    //   tickets.forEach(ticket => {
    //     if (
    //         ticket.package_options &&
    //         ticket.package_options.length > 0 &&
    //         ticket.quantity_tickets == 1 &&
    //         validMenuItems
    //     ) {
    //       if (!ticket.optionsSelected) {
    //         validMenuItems = false;
    //       } else {
    //         var allSelected = true;
    //         for (var i = 0; i < ticket.optionsSelected.length; i++) {
    //           if (ticket.optionsSelected[i] === undefined) {
    //             allSelected = false;
    //           }
    //         }
    //         validMenuItems =
    //             (ticket.package_options.length == ticket.optionsSelected.length) && allSelected;
    //       }
    //     }
    //   });
    //
    //   if (!validMenuItems) {
    //     this.$notify.error({
    //       message: "Please select all your menu options",
    //       title: "Choose Menu Options"
    //     });
    //   }
    //
    //   return validMenuItems;
    // }
  }
};
</script>
